import { LAND_TYPE } from "@libs/interfaces/layouts"
import { land_group_id } from "@libs/layouts"
import { __, setMaxHeightByClass } from "@libs/utilities"
import switchToBlog from "@/modules/pe-basic-module/hooks/switchToBlog"
import Feed from "@/modules/pe-basic-module/views/core/Feed"
import { useEffect, useState } from "react"
import { useSearchParams } from "react-router-dom"
import { clearFestival } from "../../hooks/festival"
import FestivalButton from "./FestivalButton"
import FestivalFilter from "./FestivalFilter"

const getLandsPaging = () => { 
    if( !!land_group_id() ) {
        return ` meta_relation: "AND"  metas: [  {key: "land_type", value: "${LAND_TYPE.EVENT}"}, { key: "land_group_id", value: "${ land_group_id() }" },  { key: "hidden", value_bool: false }, { key: "archived", value_bool: false } ] `
    }
    return ` meta_relation: "AND"  metas: [  {key: "land_type", value: "${LAND_TYPE.EVENT}"}, { key: "hidden", value_bool: false }, { key: "archived", value_bool: false } ] `
}

/* Protopia Ecosystem component */
export interface IFestivalListProps {

}
const FestivalList = (props: IFestivalListProps): JSX.Element => { 
    const [paging, setPaging] = useState<string>( getLandsPaging() )
    const [searchParams, ] = useSearchParams()
    // const user:IUser = useMainStore((state:IState) =>state.user)
    useEffect(() => { 
        setMaxHeightByClass( 'card-title' )
        setMaxHeightByClass( 'card-text' )
        clearFestival()
        switchToBlog( "-1" )
    }, []) 
    useEffect(() => {
        if( searchParams.get("filter") === "all-current" ) {
            const pagination = ` meta_relation: "AND" metas: [ {key: "land_type", value: "${LAND_TYPE.EVENT}"}, { key: "hidden", value_bool: false },  { key: "archived", value_bool: false }, { key:"status", value_array: "1,2" } ] ` 
            console.log( pagination )
            setPaging( pagination )
            // setPaging(` relation: "AND" metas: [  {key: "land_type", value: "${LAND_TYPE.EVENT}"}, { key: "hidden", value_bool: false }, { key:"status", value_numeric: 0, compare: ">" }, { key:"status", value_numeric:3, compare: "<" } ] `)
        }
        else if( searchParams.get("filter") === "all-before" ) {
            setPaging(` meta_relation: "AND" metas: [ {key: "land_type", value: "${LAND_TYPE.EVENT}"}, { key: "hidden", value_bool: false },  { key: "archived", value_bool: false }, { key:"status", value: "0" } ] `)
        }
        else if( searchParams.get("filter") === "all-finished" ) {
            setPaging(` meta_relation: "AND" metas: [ {key: "land_type", value: "${LAND_TYPE.EVENT}"}, { key: "hidden", value_bool: false }, { key:"status", value: "3" } ] `)
        }
        else {
            setPaging( getLandsPaging() )
        }
    }, [ searchParams ]) 

    return <div className=' container h-100 flex-centered flex-column '>
        <div className="flex-centered flex-md-nowrap flex-wrap py-3">
            <h3 className="m-0 text-nowrap">
                {__("Choose Festival")}
            </h3> 
            <FestivalFilter />
        </div>
        <Feed 
            data_type="Land"
            offset={0} 
            class_name='row'
            containerClassName="container"  
            component={ FestivalButton } 
            paging={paging}
            onLoading = {( ) => {
                setMaxHeightByClass( 'card-title' )
                setMaxHeightByClass( 'card-text' ) 
            }}
            topPagiHide
            params={{
                col:3
            }}
        /> 
    </div> 
}
export default FestivalList